import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home5 from "./Pages/Home5";
import About2 from "./Pages/About2";
import Error from "./Pages/Error";
import ProjectDetail1 from "./Pages/ProjectDetail1";
import ShopGrid from "./Pages/ShopGrid";
import ShopList from "./Pages/ShopList";
import Faq from "./Pages/Faq";
import ContactUs from "./Pages/ContactUs";
import ScrollToTop from "./Common/ScrollToTop";

class Components extends React.Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <ScrollToTop />
        <div className="page-wraper">
          <Routes>
            <Route path="/" element={<Home5 />} />
            <Route path="/about" element={<About2 />} />
            <Route path="/services/:projectId" element={<ProjectDetail1 />} />
            {/* <Route path="/rentals" element={<ShopGrid />} /> */}
            <Route path="/rentals" element={<ShopList />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact-us" element={<ContactUs />} />

            <Route element={<Error />} />
          </Routes>
        </div>
      </BrowserRouter>
    );
  }
}

export default Components;
